export const removeSubString = (value: string, substring: string | RegExp) =>
  value.trim().replaceAll(substring, '');

export const removeStringSpaces = (value: string) => removeSubString(value, /\s/g);
